module.exports = __webpack_public_path__ + "img/dlp.6c278f23.jpg";